import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import i18next from 'i18next';
import { Badge } from 'react-bootstrap';
import { CollectionOrderStates } from 'shared-pages/common/constants';
import '../../styles/status-badge.css';

export const CollectionOrderStatusBadge = (props) => {
  // console.log('$$$$', props, typeof props.value);
  const { value, name } = props ? props : { value: 1, name: 'Μή Δρομολογημένη' };
  function colorVariant(value): string {
    return value === CollectionOrderStates.NotRouted
      ? 'bg-warning'
      : value === CollectionOrderStates.Routed
      ? 'bg-primary'
      : value === CollectionOrderStates.Executed
      ? 'bg-success'
      : value === CollectionOrderStates.ApplicationRejected
      ? 'bg-danger'
      : value === CollectionOrderStates.ApplicationSubmitted
      ? 'bg-info'
      : value === CollectionOrderStates.TemporarySaved
      ? 'bg-secondary'
      : value === CollectionOrderStates.OrganizationCompleted
      ? 'bg-tertiary'
      : value === CollectionOrderStates.PackageShipmentCompleted
      ? 'bg-quaternary'
      : value === CollectionOrderStates.CollectorOrder
      ? 'bg-quinary'
      : value === CollectionOrderStates.ScheduledCollectorCollection
      ? 'bg-senary'
      : 'bg-primary';
  }

  return (
    <Badge
      pill={true}
      className={`${colorVariant(value)} badge-status min-w-100  text-white align-middle`}
      style={{
        minWidth: '134px',
        textAlign: 'center',
        padding: '4px 0px 5px 8px',
      }}
    >
      {name ? name : '---'}&nbsp;&nbsp;
    </Badge>
  );
};
